import SkeletonTable from "@/components/SkeletonTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useTahun } from "@/hooks/useTahun";

const getListRekapPesertaKepemimpinan = async (tahun: String) => {
  const response = await api.get("/setting/verifikator-kepemimpinan/index", {
    withCredentials: true,
    params: { tahun },
  });
  return response.data;
};

export default function SettingVerifikatorKepemimpinanPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listRekapPesertaKepemimpinan", selectedTahun?.label],
    queryFn: () => getListRekapPesertaKepemimpinan(selectedTahun?.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  );
}
